import "./person.svg";
import "./linkedin.svg";
import "./link.svg";
import "./envelope.svg";
import "./blue.svg";
import "./yellow.svg";
import "./red.svg";
import "./repo.svg";
import "./search.svg";
